import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import UICloseButton from 'UIComponents/button/UICloseButton';
import UITextInput from 'UIComponents/input/UITextInput';
import * as Colors from 'HubStyleTokens/colors';
import { FixedElevatedHeader, HeaderContainer } from '../styles/FullScreenSearch.styles';
import { useCallback } from 'react';
export const FullScreenSearchHeader = ({
  onClose,
  onSearchChange,
  inputValue,
  seleniumKey,
  searchPlaceholder,
  searchAutofocus
}) => {
  const onKeyDown = useCallback(event => {
    if (event.key === 'Enter') {
      event.preventDefault();
      return false;
    }

    return true;
  }, []);
  return /*#__PURE__*/_jsx(FixedElevatedHeader, {
    className: "m-x-auto",
    children: /*#__PURE__*/_jsxs(HeaderContainer, {
      children: [/*#__PURE__*/_jsx(UICloseButton, {
        color: Colors.EERIE,
        onClick: onClose
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          flex: '1',
          margin: '0 24px 16px'
        },
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            height: '44px'
          }
        }), /*#__PURE__*/_jsx(UITextInput, {
          autoFocus: searchAutofocus,
          "data-selenium": `${seleniumKey}-mobile-input`,
          placeholder: searchPlaceholder,
          value: inputValue,
          onChange: onSearchChange,
          onKeyDown: onKeyDown
        })]
      })]
    })
  });
};